import { render, staticRenderFns } from "./bankCard.vue?vue&type=template&id=5e145893&scoped=true"
import script from "./bankCard.vue?vue&type=script&lang=js"
export * from "./bankCard.vue?vue&type=script&lang=js"
import style0 from "./bankCard.vue?vue&type=style&index=0&id=5e145893&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e145893",
  null
  
)

export default component.exports